import React from 'react'
import CommonSurveyQuestionList from '../../../common/pages/secure/SurveyQuestionList'
import Config from '../../../Config'

class SurveySmallQuestionList extends CommonSurveyQuestionList {
  constructor (props) {
    super(props)
    this.apiUrl = Config.adminApiUrl.surveyQuestionSetting
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
    this.serveyCategory = 'small'
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'add':
        this.props.history.push(`/admin/survey_smallquestion/add/${this.state.surveyQuestionSettingList.mediumQuestions[0].id}`)
        break
      case 'edit':
        this.props.history.push(`/admin/survey_mediumquestion/edit/${this.state.surveyQuestionSettingList.mediumQuestions[0].id}`)
        break
      case 'back':
        this.props.history.push(`/admin/survey_mediumquestion/${this.state.surveyQuestionSettingList.bigQuestions[0].id}`)
        break
      default:
        break
    }
  }
  renderPageNavi () {
    return (
      <section className='nav-page'>
        <div className='container'>
          <div className='row'>
            <div className='span8'>
              <header className='page-header'>
                <h3>アンケート設問設定<br />
                  <small>こちらからアンケートの設問を管理できます。</small>
                </h3>
              </header>
            </div>
            <div className='span8'>
              <ul className='nav nav-pills'>
                {this.state.surveyQuestionSettingList.mediumQuestions[0] && this.state.surveyQuestionSettingList.mediumQuestions[0].createDateTime && (
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='新規の小設問を登録' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('add')}>
                    <i className='icon-plus icon-large' /><br /><span>新規</span>
                  </a>
                </li>
                )}
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='中設問の編集' className='text-center kw-btn-success' onClick={(e) => this.onPageMenuClicked('edit')}>
                    <i className='icon-edit icon-large' /><br /><span>中設問</span>
                  </a>
                </li>
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}>
                    <i className='icon-arrow-left icon-large' /><span>戻る</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default SurveySmallQuestionList



// WEBPACK FOOTER //
// ./src/admin/pages/secure/SurveySmallQuestionList.js